import styled from 'styled-components/macro'

export const LoadingBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 15;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`
export const LoadingWrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 150px;
`

export const LoadingIconWrap = styled.div`
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  display: inline-block;
  width: 100px;
  height: 100px;
  border: 6px solid rgb(235, 235, 255);
  border-radius: 50%;
  border-top-color: rgb(0, 58, 145);
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;
  z-index: 20;

  @media ${(props) => props.theme.media.md} {
    width: 7rem;
    height: 7rem;
    border: 0.8rem solid rgb(235, 235, 255);
    border-top-color: rgb(0, 58, 145);
  }
`
export const LoadingTit = styled.p`
  color: #fff;
  margin-top: 20px;
  font-size: 16px;
  @media ${(props) => props.theme.media.md} {
    font-size: 1.5rem;
  }
`
